<template>
  <list mode="export" :items="exports" @load="onLoad" @delete="onDelete" />
</template>

<script>
import List from "@/components/list"
import Exports from "@/api/exports"
export default {
  name: "Exports",
  components: { List },
  data() {
    return {
      exports: {
        limit: 20,
        offset: 0,
        count: 0,
        results: []
      }
    }
  },
  methods: {
    onLoad() {
      if (this.exports.count == 0 || this.exports.offset < this.exports.count) {
        this.setBusy(true)
        Exports.list(this.exports.offset).then(response => {
          this.exports.count = response.data.count
          this.exports.results.push(...response.data.results)
          this.exports.offset += this.exports.limit
        }).finally(() => this.setBusy(false))
      }
    },
    onDelete(items) {
      Exports.delete({ items: items }).then(response => {
        this.notify(response.data)
        this.refresh()
      })
    }
  }
}
</script>